import DeprecatedModulePage from './DeprecatedModulePage';

export default DeprecatedModulePage;
